import { EditorState } from '@candulabs/craft';

import { mergeElements } from './mergeElements';
import { removeEmptyLinks } from './removeEmptyLinks';
import { removeOrphanNodes } from './removeOrphanNodes';
import { splitRTE } from './splitRTE';
import { wrapStandaloneElements } from './wrapStandaloneElements';

export const normalizeRTE = (editorState: EditorState) => {
  // Break the Slate node if there's non-Slate elements in it
  splitRTE(editorState);

  // Wrap Standalone RTE elements inside a <RichText /> node
  wrapStandaloneElements(editorState);

  // Combine adjacent Slate nodes together
  mergeElements(editorState);

  // Remove any unnecessary RichText nodes (ie: a <RichText /> without any descendant <Text /> node)
  removeOrphanNodes(editorState);

  // Remove any Link that doesnt have a text
  removeEmptyLinks(editorState);

  return editorState;
};
